import { Close, InfoOutlined } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useYaMetrika } from '@/entities/yaMetrika';
import { TableSortOrder, viewSettingsStore } from '@/features/viewSettings';
import { AnalyticsEvent } from '@/types/yametrika';

import { AntSwitch } from './ui';

import s from './SettingsDialog.module.scss';

type SettingsDialoglProps = {
  open: boolean;
  closeModal: () => void;
};

const SettingsDialog: React.FC<SettingsDialoglProps> = observer(({ open, closeModal }) => {
  const { sendEvent } = useYaMetrika();
  const { hideWeekends, setHideWeekends, tableSortOrder, setTableSortOrder } = viewSettingsStore;

  const onHideWeekendsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const event = e.target.checked ? AnalyticsEvent.hideWeekends : AnalyticsEvent.showWeekends;

    setHideWeekends(e.target.checked);
    sendEvent(event);
  };

  const onTableSortOrderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTableSortOrder(e.target.checked ? TableSortOrder.TaskKey : TableSortOrder.Time);
    sendEvent(AnalyticsEvent.settingsChangeSortOrder);
  };

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth
      maxWidth="sm"
      sx={{
        '.MuiPaper-root': {
          borderRadius: '12px',
        },
      }}
    >
      <div className={s.settings__header}>
        <h1 className={s.settings_title}>Настройки отображения</h1>
        <IconButton onClick={closeModal} size="small">
          <Close />
        </IconButton>
      </div>
      <DialogContent>
        <div className={s.settings__content}>
          <div className={s.settings__item}>
            <div>
              <div className={s.settings__item_header}>
                <p>Скрыть выходные</p>
                <Tooltip
                  title="Эта настройка применяется только в режиме просмотра недели"
                  arrow
                  placement="top"
                >
                  <IconButton size="small" sx={{ padding: '4px', color: 'var(--secondary-color)' }}>
                    <InfoOutlined sx={{ fontSize: '18px' }} />
                  </IconButton>
                </Tooltip>
              </div>
              <span className={s.settings__item_hint}>Только в режиме недели</span>
            </div>
            <AntSwitch defaultChecked={hideWeekends} onChange={onHideWeekendsChange} />
          </div>
          <div className={s.settings__item}>
            <div>
              <div className={s.settings__item_header}>
                <p>Сортировка по ключу задачи</p>
                <Tooltip
                  title="Сортировать задачи по ключу (PROJECT-123) вместо времени начала"
                  arrow
                  placement="top"
                >
                  <IconButton size="small" sx={{ padding: '4px', color: 'var(--secondary-color)' }}>
                    <InfoOutlined sx={{ fontSize: '18px' }} />
                  </IconButton>
                </Tooltip>
              </div>
              <span className={s.settings__item_hint}>По умолчанию — по времени</span>
            </div>
            <AntSwitch
              checked={tableSortOrder === TableSortOrder.TaskKey}
              onChange={onTableSortOrderChange}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});

export { SettingsDialog };
